/* ==========================================================================
   PRAY4LIVNG — p4l.js
   Cart drawer, quick view, predictive search, countdown, sort, wishlist.
   Gebruikt alleen Shopify's eigen AJAX API (/cart.js, /cart/add.js, etc.)
   ========================================================================== */
(() => {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* Geld: centen -> € met Nederlandse notatie (past bij shop-valuta EUR) */
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
    } catch (e) {
      return '€' + ((cents || 0) / 100).toFixed(2);
    }
  };

  /* ---------- overlay helpers ---------- */
  const lock = () => document.body.classList.add('p4l-lock');
  const unlock = () => {
    if (!document.querySelector('.p4l-veil.is-open, .p4l-qv.is-open')) document.body.classList.remove('p4l-lock');
  };
  const openVeil = () => { const v = $('#p4lVeil'); if (v) v.classList.add('is-open'); lock(); };
  const closeAll = () => {
    $$('.p4l-veil.is-open, .p4l-menu.is-open, .p4l-search.is-open, .p4l-drawer.is-open, .p4l-qv.is-open')
      .forEach((el) => el.classList.remove('is-open'));
    unlock();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-p4l-open]');
    if (opener) {
      const which = opener.getAttribute('data-p4l-open');
      closeAll();
      openVeil();
      const panel = { menu: '#p4lMenu', search: '#p4lSearch', cart: '#p4lDrawer' }[which];
      if (panel) {
        $(panel).classList.add('is-open');
        if (which === 'cart') refreshCart();
        if (which === 'search') {
          const input = $('#p4lSearchInput');
          if (input) setTimeout(() => input.focus(), 350);
        }
      }
      return;
    }
    if (e.target.closest('[data-p4l-close]')) { closeAll(); return; }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- toast ---------- */
  let toastTimer = null;
  const toast = (msg) => {
    const t = $('#p4lToast');
    if (!t) return;
    $('#p4lToastMsg').textContent = msg;
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-open'), 2600);
  };

  /* ---------- cart ---------- */
  const drawer = () => $('#p4lDrawer');

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function addItem(id, qty) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }
  async function changeItem(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  function paintCounts(cart) {
    $$('[data-p4l-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  }

  function paintDrawer(cart) {
    const d = drawer();
    if (!d) return;
    const threshold = parseInt(d.getAttribute('data-threshold') || '15000', 10);
    const itemsBox = $('#p4lCartItems');
    const foot = $('#p4lCartFoot');
    const shipTxt = $('#p4lShipTxt');
    const shipBar = $('#p4lShipBar');

    /* free shipping bar */
    const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (shipBar) shipBar.style.width = pct + '%';
    if (shipTxt) {
      shipTxt.textContent = cart.total_price >= threshold
        ? 'GRATIS VERZENDING ONTGRENDELD ✦'
        : money(threshold - cart.total_price) + ' TOT GRATIS VERZENDING';
    }

    if (!cart.items || cart.items.length === 0) {
      itemsBox.innerHTML =
        '<div class="p4l-cart-empty"><div><div class="p4l-ava">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h15l-1.5 9h-12z"/><path d="M6 7l-1-4H2"/><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/></svg></div>' +
        '<b>Je winkelwagen is leeg</b><p>Faith without works is dead.<br>Cop something.</p>' +
        '<a href="/collections/all" class="p4l-btn-dark" data-p4l-close>SHOP ALL</a></div></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    itemsBox.innerHTML = cart.items.map((item) => {
      const img = (item.image || '').replace(/(\?.*)?$/, '') + '?width=200';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return (
        '<div class="p4l-cart-item">' +
          '<a class="p4l-cart-img" href="' + item.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' +
          '<div class="p4l-cart-info"><div class="p4l-cart-top"><div>' +
            '<p class="p4l-cart-name">' + item.product_title + '</p>' +
            (variant ? '<p class="p4l-cart-var">Maat ' + variant + '</p>' : '') +
          '</div><button class="p4l-cart-del" data-p4l-remove="' + item.key + '" aria-label="Verwijder">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>' +
          '</button></div>' +
          '<div class="p4l-cart-row"><div class="p4l-qty">' +
            '<button data-p4l-dec="' + item.key + '" aria-label="Minder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/></svg></button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-p4l-inc="' + item.key + '" aria-label="Meer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div><p class="p4l-cart-price">' + money(item.final_line_price) + '</p></div>' +
        '</div></div>'
      );
    }).join('');

    const sub = $('#p4lSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
    const head = $('#p4lCartTitle');
    if (head) head.textContent = 'JE WINKELWAGEN (' + cart.item_count + ')';
  }

  async function refreshCart() {
    try {
      const cart = await getCart();
      paintCounts(cart);
      paintDrawer(cart);
    } catch (e) { /* stil */ }
  }

  /* qty + / − / remove via event delegation */
  document.addEventListener('click', async (e) => {
    const inc = e.target.closest('[data-p4l-inc]');
    const dec = e.target.closest('[data-p4l-dec]');
    const rem = e.target.closest('[data-p4l-remove]');
    const key = inc ? inc.getAttribute('data-p4l-inc') : dec ? dec.getAttribute('data-p4l-dec') : rem ? rem.getAttribute('data-p4l-remove') : null;
    if (!key) return;
    e.preventDefault();
    try {
      let cart;
      if (rem) {
        cart = await changeItem(key, 0);
        toast('VERWIJDERD UIT WINKELWAGEN');
      } else {
        const current = await getCart();
        const line = current.items.find((i) => i.key === key);
        if (!line) return;
        cart = await changeItem(key, line.quantity + (inc ? 1 : -1));
      }
      paintCounts(cart);
      paintDrawer(cart);
    } catch (err) { toast('ER GING IETS MIS — PROBEER OPNIEUW'); }
  });

  /* quick-add knoppen */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-p4l-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = parseInt(btn.getAttribute('data-p4l-add'), 10);
    const name = btn.getAttribute('data-p4l-name') || 'Product';
    btn.disabled = true;
    try {
      await addItem(variantId, 1);
      const cart = await getCart();
      paintCounts(cart);
      paintDrawer(cart);
      toast(name + ' TOEGEVOEGD');
      closeAll();
      openVeil();
      drawer().classList.add('is-open');
    } catch (err) {
      toast('NIET OP VOORRAAD — BEKIJK HET PRODUCT');
    }
    btn.disabled = false;
  });

  /* ---------- quick view ---------- */
  let qvProduct = null;
  let qvVariant = null;
  let qvQty = 1;

  function pickDefaultVariant(product) {
    /* voorkeur: maat M, anders eerste beschikbare */
    const pool = product.variants.filter((v) => v.available);
    const m = pool.find((v) => v.title === 'M' || v.option1 === 'M' || v.option2 === 'M' || v.option3 === 'M');
    return m || pool[0] || product.variants[0];
  }

  function paintQvVariant() {
    if (!qvProduct || !qvVariant) return;
    const priceEl = $('#p4lQvPrice');
    if (priceEl) priceEl.textContent = money(qvVariant.price);
    const compEl = $('#p4lQvCompare');
    if (compEl) {
      if (qvVariant.compare_at_price && qvVariant.compare_at_price > qvVariant.price) {
        compEl.textContent = money(qvVariant.compare_at_price);
        compEl.style.display = '';
      } else { compEl.style.display = 'none'; }
    }
    const addBtn = $('#p4lQvAdd');
    if (addBtn) {
      addBtn.disabled = !qvVariant.available;
      addBtn.innerHTML = qvVariant.available ? 'IN WINKELWAGEN' : 'UITVERKOCHT';
    }
    /* size buttons sync */
    $$('#p4lQvSizes .p4l-size').forEach((b) => {
      const val = b.getAttribute('data-value');
      const idx = parseInt(b.getAttribute('data-opt'), 10);
      const key = idx === 1 ? 'option1' : idx === 2 ? 'option2' : 'option3';
      b.classList.toggle('is-active', qvVariant[key] === val);
    });
  }

  async function openQuick(handle) {
    const qv = $('#p4lQv');
    if (!qv || !handle) return;
    closeAll();
    openVeil();
    qv.classList.add('is-open');
    $('#p4lQvBox').innerHTML = '<div style="padding:80px 20px;text-align:center;font-weight:700;">Laden…</div>';
    try {
      const r = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
      const p = await r.json();
      qvProduct = p;
      qvVariant = pickDefaultVariant(p);
      qvQty = 1;

      const imgs = (p.images || []).slice(0, 4);
      const mainImg = imgs[0] || '';
      const sizeOptIdx = p.options.findIndex((o) => /size|maat/i.test(o.name));
      const sizeOpt = sizeOptIdx >= 0 ? p.options[sizeOptIdx] : null;

      /* voorraad per maat bepalen */
      const optKey = sizeOptIdx === 0 ? 'option1' : sizeOptIdx === 1 ? 'option2' : 'option3';
      const sizeBtns = sizeOpt ? sizeOpt.values.map((val) => {
        const hasStock = p.variants.some((v) => v[optKey] === val && v.available);
        return '<button class="p4l-size' + (hasStock ? '' : ' is-disabled') + '" data-opt="' + (sizeOptIdx + 1) + '" data-value="' + val + '">' + val + '</button>';
      }).join('') : '';

      /* badge uit tags */
      let badge = '';
      (p.tags || []).forEach((t) => {
        if (t.toLowerCase().indexOf('badge:') === 0) badge = t.slice(6).toUpperCase();
      });

      $('#p4lQvBox').innerHTML =
        '<button class="p4l-qv-close" data-p4l-close aria-label="Sluiten"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="p4l-qv-media"><div class="p4l-qv-main"><img id="p4lQvMain" src="' + mainImg + '" alt=""></div>' +
          (imgs.length > 1 ? '<div class="p4l-qv-thumbs">' + imgs.map((src, i) =>
            '<button class="' + (i === 0 ? 'is-active' : '') + '" data-p4l-thumb="' + src + '"><img src="' + src + '" alt="" loading="lazy"></button>'
          ).join('') + '</div>' : '') +
        '</div>' +
        '<div class="p4l-qv-info">' +
          '<div class="p4l-qv-tags">' +
            (badge ? '<span class="p4l-badge' + (badge === 'LIMITED' ? ' red' : '') + '">' + badge + '</span>' : '') +
            (p.type ? '<span class="p4l-tagline">' + p.type.toUpperCase() + '</span>' : '') +
          '</div>' +
          '<h3 class="p4l-qv-name">' + p.title + '</h3>' +
          (p.vendor ? '<p class="p4l-qv-sub">' + p.vendor + '</p>' : '') +
          '<div class="p4l-qv-price"><b id="p4lQvPrice"></b><s id="p4lQvCompare" style="display:none"></s></div>' +
          '<div class="p4l-qv-desc">' + (p.description || '') + '</div>' +
          (sizeOpt ? '<div class="p4l-qv-sizes"><p>KIES MAAT — ' + sizeOpt.name.toUpperCase() + '</p><div class="p4l-size-row" id="p4lQvSizes">' + sizeBtns + '</div></div>' : '<div id="p4lQvSizes"></div>') +
          '<div class="p4l-qv-cta"><div class="p4l-qty">' +
            '<button id="p4lQvMinus" aria-label="Minder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/></svg></button>' +
            '<span id="p4lQvQty">1</span>' +
            '<button id="p4lQvPlus" aria-label="Meer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div><button class="p4l-qv-add" id="p4lQvAdd">IN WINKELWAGEN</button></div>' +
          '<ul class="p4l-qv-meta">' +
            '<li>✓ Premium kwaliteit — officieel PRAY4LIVNG</li>' +
            '<li>✓ 30 dagen gratis retourneren (EU)</li>' +
            '<li>✓ Verzending met track &amp; trace</li>' +
          '</ul>' +
          '<div style="margin-top:12px;text-align:center;"><a href="/products/' + p.handle + '" style="font-size:12px;font-weight:700;letter-spacing:0.14em;text-decoration:underline;text-underline-offset:4px;">BEKIJK VOLLEDIGE PRODUCTPAGINA</a></div>' +
        '</div>';

      paintQvVariant();
    } catch (e) {
      $('#p4lQvBox').innerHTML = '<div style="padding:80px 20px;text-align:center;font-weight:700;">Kon product niet laden. <a href="/products/' + handle + '" style="text-decoration:underline;">Bekijk hier</a>.</div>';
    }
  }

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-p4l-quick]');
    if (q) { e.preventDefault(); openQuick(q.getAttribute('data-p4l-quick')); return; }
    const thumb = e.target.closest('[data-p4l-thumb]');
    if (thumb) {
      $('#p4lQvMain').src = thumb.getAttribute('data-p4l-thumb');
      $$('#p4lQvBox .p4l-qv-thumbs button').forEach((b) => b.classList.remove('is-active'));
      thumb.classList.add('is-active');
      return;
    }
    const size = e.target.closest('#p4lQvSizes .p4l-size');
    if (size && qvProduct) {
      const idx = parseInt(size.getAttribute('data-opt'), 10);
      const val = size.getAttribute('data-value');
      const key = idx === 1 ? 'option1' : idx === 2 ? 'option2' : 'option3';
      const found = qvProduct.variants.find((v) => v[key] === val && v.available)
        || qvProduct.variants.find((v) => v[key] === val);
      if (found) { qvVariant = found; paintQvVariant(); }
      return;
    }
    if (e.target.closest('#p4lQvMinus')) { qvQty = Math.max(1, qvQty - 1); $('#p4lQvQty').textContent = qvQty; return; }
    if (e.target.closest('#p4lQvPlus')) { qvQty = qvQty + 1; $('#p4lQvQty').textContent = qvQty; return; }
    if (e.target.closest('#p4lQvAdd')) {
      if (!qvVariant || !qvVariant.available) return;
      addItem(qvVariant.id, qvQty).then(() => {
        refreshCart();
        toast(qvProduct.title.toUpperCase() + ' TOEGEVOEGD');
        closeAll();
        openVeil();
        drawer().classList.add('is-open');
      }).catch(() => toast('NIET OP VOORRAAD'));
      return;
    }
  });

  /* ---------- predictive search ---------- */
  let searchTimer = null;
  async function runSearch(q) {
    const grid = $('#p4lSearchGrid');
    const label = $('#p4lSearchLabel');
    if (!q || q.trim().length < 2) {
      if (label) label.textContent = 'POPULAIR — TYPE OM TE ZOEKEN';
      if (grid) grid.innerHTML = '';
      return;
    }
    try {
      const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } });
      const data = await r.json();
      const results = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (label) label.textContent = 'RESULTATEN (' + results.length + ')';
      if (grid) {
        grid.innerHTML = results.length === 0
          ? '<div class="p4l-search-none" style="grid-column:1/-1;">Niets gevonden voor "' + q + '".</div>'
          : results.map((p) => {
              const img = p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=400' : '';
              return '<a href="' + p.url + '"><div class="p4l-search-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div><b>' + p.title + '</b><span>' + (p.price || '') + '</span></a>';
            }).join('');
      }
    } catch (e) { /* stil */ }
  }
  document.addEventListener('input', (e) => {
    if (e.target && e.target.id === 'p4lSearchInput') {
      clearTimeout(searchTimer);
      const val = e.target.value;
      searchTimer = setTimeout(() => runSearch(val), 250);
    }
  });
  document.addEventListener('click', (e) => {
    const tag = e.target.closest('[data-p4l-tag]');
    if (tag) {
      const input = $('#p4lSearchInput');
      input.value = tag.getAttribute('data-p4l-tag');
      runSearch(input.value);
      input.focus();
    }
  });

  /* ---------- wishlist ---------- */
  const WISH_KEY = 'p4l-wish';
  const getWish = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } };
  const paintWish = () => {
    const list = getWish();
    $$('[data-p4l-wish]').forEach((b) => b.classList.toggle('is-active', list.indexOf(b.getAttribute('data-p4l-wish')) >= 0));
  };
  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-p4l-wish]');
    if (!w) return;
    e.preventDefault();
    const id = w.getAttribute('data-p4l-wish');
    let list = getWish();
    if (list.indexOf(id) >= 0) { list = list.filter((x) => x !== id); toast('VERWIJDERD VAN VERLANGLIJST'); }
    else { list.push(id); toast('BEWAARD OP VERLANGLIJST ♥'); }
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) {}
    paintWish();
  });

  /* ---------- shop grid: filteren + sorteren, in dezelfde pagina ---------- */
  const gridState = new WeakMap();

  const normalized = (value) => String(value || '').trim().toLowerCase();

  function matchesCategory(card, button) {
    if (!button || button.getAttribute('data-p4l-filter') === 'all') return true;

    const method = normalized(button.getAttribute('data-p4l-by')) || 'auto';
    const value = normalized(button.getAttribute('data-p4l-value'));
    const collection = normalized(button.getAttribute('data-p4l-collection'));
    const type = normalized(card.getAttribute('data-p4l-type'));
    const title = normalized(card.getAttribute('data-p4l-title'));
    const tags = (card.getAttribute('data-p4l-tags') || '').split('|').map(normalized);
    const collections = (card.getAttribute('data-p4l-collections') || '').split('|').map(normalized);

    const typeHit = !!value && type === value;
    const tagHit = !!value && tags.includes(value);
    const collectionHit = !!collection && collection !== 'all' && collections.includes(collection);
    const titleHit = !!value && title.includes(value);

    if (method === 'type') return typeHit;
    if (method === 'tag') return tagHit;
    if (method === 'collection') return collectionHit;
    if (method === 'title') return titleHit;

    // Bestaande blokken hebben alleen een label en soms een collectielink.
    // Voor "TEES" zonder producttype herkent dit ook "... TEE" in de titel.
    const singular = value.endsWith('s') ? value.slice(0, -1) : value;
    const titleWords = title.split(/[^a-z0-9]+/);
    const titleFallback = !type && singular.length > 2 && titleWords.includes(singular);
    return typeHit || tagHit || collectionHit || titleFallback;
  }

  /* ---------- maatfilter ---------- */
  const SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '2xl', '3xl', '4xl', 'one size', 'os'];

  function matchesSize(card, sizes) {
    if (!sizes || !sizes.length) return true;
    const have = (card.getAttribute('data-p4l-sizes') || '').split('|').map(normalized);
    return sizes.some((s) => have.includes(s));
  }

  function buildSizeBar(scope, cards) {
    const bar = $('[data-p4l-sizebar]', scope);
    const list = bar ? $('[data-p4l-sizelist]', bar) : null;
    if (!bar || !list) return;
    const found = new Set();
    cards.forEach((card) => {
      (card.getAttribute('data-p4l-sizes') || '').split('|').map(normalized).filter(Boolean).forEach((s) => found.add(s));
    });
    const sizes = Array.from(found).sort((a, b) => {
      const ia = SIZE_ORDER.indexOf(a);
      const ib = SIZE_ORDER.indexOf(b);
      if (ia > -1 && ib > -1) return ia - ib;
      if (ia > -1) return -1;
      if (ib > -1) return 1;
      const na = parseFloat(a);
      const nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return a.localeCompare(b);
    });
    list.innerHTML = '';
    sizes.forEach((s) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'p4l-sizechip';
      b.setAttribute('data-p4l-size', s);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = s.toUpperCase();
      list.appendChild(b);
    });
    bar.hidden = sizes.length === 0;
  }

  function syncSizeUI(scope, st) {
    const sizes = st.sizes || [];
    $$('[data-p4l-size]', scope).forEach((b) => {
      const on = sizes.includes(b.getAttribute('data-p4l-size'));
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const clear = $('[data-p4l-size-clear]', scope);
    if (clear) clear.hidden = sizes.length === 0;
  }

  function updateFilterCounts(scope, cards) {
    const sizeState = (gridState.get(scope) || {}).sizes || [];
    $$('.p4l-chips [data-p4l-filter]', scope).forEach((button) => {
      const count = cards.filter((card) => matchesCategory(card, button) && matchesSize(card, sizeState)).length;
      const number = $('[data-p4l-chip-count]', button);
      if (number) number.textContent = count;
    });
  }

  function applyGrid(scope, animate) {
    const grid = $('[data-p4l-cards]', scope);
    if (!grid) return;
    const st = gridState.get(scope) || { filter: 'all', sort: 'featured' };
    const cards = $$('[data-p4l-card]', grid);
    const activeButton = $$('.p4l-chips [data-p4l-filter]', scope)
      .find((button) => button.getAttribute('data-p4l-filter') === st.filter);

    /* 1. sorteren */
    const sorted = cards.slice();
    if (st.sort === 'low') {
      sorted.sort((a, b) => parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')));
    } else if (st.sort === 'high') {
      sorted.sort((a, b) => parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')));
    } else {
      sorted.sort((a, b) => parseInt(a.getAttribute('data-idx'), 10) - parseInt(b.getAttribute('data-idx'), 10));
    }
    sorted.forEach((c) => grid.appendChild(c));

    /* 2. filteren (verbergen, niet herladen) */
    let visible = 0;
    let lastVisible = null;
    sorted.forEach((c) => {
      const hit = matchesCategory(c, activeButton) && matchesSize(c, st.sizes);
      c.classList.toggle('is-hidden', !hit);
      c.classList.remove('p4l-last-visible');
      if (hit) {
        visible++;
        lastVisible = c;
        if (animate) {
          c.classList.remove('p4l-pop');
          void c.offsetWidth; /* animatie opnieuw triggeren */
          c.style.animationDelay = (Math.min(visible, 12) * 35) + 'ms';
          c.classList.add('p4l-pop');
        }
      }
    });
    grid.setAttribute('data-visible-count', String(visible));
    if (lastVisible) lastVisible.classList.add('p4l-last-visible');

    /* 3. leeg-state */
    const none = $('.p4l-grid-none', scope);
    if (none) none.hidden = visible !== 0;

    /* 4. telling + progressiebalk laten meelopen */
    const count = $('[data-p4l-count]', scope);
    const bar = $('[data-p4l-progress]', scope);
    if (count) {
      count.textContent = visible === cards.length
        ? cards.length + ' PRODUCTEN GETOOND'
        : visible + ' VAN ' + cards.length + ' PRODUCTEN GETOOND';
    }
    if (bar) bar.style.width = Math.round((visible / (cards.length || 1)) * 100) + '%';
  }

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-p4l-filter]');
    const sortBtn = e.target.closest('[data-p4l-sort]');
    const trigger = chip || sortBtn;
    if (!trigger) return;
    const scope = trigger.closest('[data-p4l-grid-scope]');
    if (!scope) return;
    e.preventDefault();

    const st = gridState.get(scope) || { filter: 'all', sort: 'featured' };

    if (chip) {
      if (chip.hasAttribute('data-p4l-reset-sizes')) {
        st.sizes = [];
        syncSizeUI(scope, st);
        gridState.set(scope, st);
        updateFilterCounts(scope, $$('[data-p4l-card]', scope));
      }
      st.filter = chip.getAttribute('data-p4l-filter');
      $$('.p4l-chips [data-p4l-filter]', scope).forEach((b) => {
        const on = b.getAttribute('data-p4l-filter') === st.filter;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    if (sortBtn) {
      st.sort = sortBtn.getAttribute('data-p4l-sort');
      $$('[data-p4l-sort]', scope).forEach((b) => b.classList.toggle('is-active', b === sortBtn));
    }

    gridState.set(scope, st);
    applyGrid(scope, true);
  });

  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('[data-p4l-size]');
    const clearBtn = e.target.closest('[data-p4l-size-clear]');
    if (!sizeBtn && !clearBtn) return;
    const scope = (sizeBtn || clearBtn).closest('[data-p4l-grid-scope]');
    if (!scope) return;
    e.preventDefault();

    const st = gridState.get(scope) || { filter: 'all', sort: 'featured' };
    st.sizes = st.sizes || [];
    if (clearBtn) {
      st.sizes = [];
    } else {
      const value = sizeBtn.getAttribute('data-p4l-size');
      st.sizes = st.sizes.includes(value) ? st.sizes.filter((x) => x !== value) : st.sizes.concat(value);
    }
    gridState.set(scope, st);
    syncSizeUI(scope, st);
    updateFilterCounts(scope, $$('[data-p4l-card]', scope));
    applyGrid(scope, true);
  });

  /* ---------- faq ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-p4l-faq]');
    if (!btn) return;
    const item = btn.closest('.p4l-faq-item');
    const wasOpen = item.classList.contains('is-open');
    $$('.p4l-faq-item.is-open', btn.closest('[data-p4l-faq-scope]')).forEach((i) => i.classList.remove('is-open'));
    if (!wasOpen) item.classList.add('is-open');
  });

  /* ---------- lookbook slider ---------- */
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-p4l-look-prev]');
    const next = e.target.closest('[data-p4l-look-next]');
    if (!prev && !next) return;
    const scope = (prev || next).closest('[data-p4l-look-scope]');
    const track = scope ? $('[data-p4l-look-track]', scope) : null;
    if (track) track.scrollBy({ left: (prev ? -1 : 1) * 360, behavior: 'smooth' });
  });

  /* ---------- countdown ---------- */
  function tickCountdown() {
    $$('[data-p4l-countdown]').forEach((el) => {
      const target = new Date(el.getAttribute('data-p4l-countdown')).getTime();
      if (isNaN(target)) return;
      let diff = target - Date.now();
      if (diff < 0) diff = 0;
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const set = (sel, val) => { const n = $(sel, el); if (n) n.textContent = String(val).padStart(2, '0'); };
      set('[data-cd-d]', d); set('[data-cd-h]', h); set('[data-cd-m]', m); set('[data-cd-s]', s);
    });
  }
  setInterval(tickCountdown, 1000);

  /* ---------- header scroll ---------- */
  function onScroll() {
    const h = $('#p4lHeader');
    if (h) h.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- init ---------- */
  function initGrids(root = document) {
    const scopes = $$('[data-p4l-grid-scope]', root);
    if (root.matches && root.matches('[data-p4l-grid-scope]')) scopes.push(root);
    scopes.forEach((scope) => {
      const grid = $('[data-p4l-cards]', scope);
      if (!grid) return;
      const st = { filter: 'all', sort: 'featured', sizes: [] };
      gridState.set(scope, st);
      buildSizeBar(scope, $$('[data-p4l-card]', grid));
      syncSizeUI(scope, st);
      updateFilterCounts(scope, $$('[data-p4l-card]', grid));
      applyGrid(scope, false);
    });
  }

  document.addEventListener('shopify:section:load', (event) => initGrids(event.target));

  document.addEventListener('DOMContentLoaded', () => {
    onScroll();
    tickCountdown();
    paintWish();
    initGrids();
    refreshCart();
  });
})();
